export const environment = {
  production: true,
  apiUrl: 'https://api.brasillis.com.br',
};
